// import JSEncrypt from 'jsencrypt';

function copyFields(data, name, fields = []) {
  return data
    .map((item) =>
      item[name].map((item2) => {
        fields.forEach((field) => {
          item2[field] = item[field];
        });
        return { ...item2 };
      })
    )
    .flat();
}
// 最大车型列表
function maxChildData(
  options = {
    data: [],
    field: '',
    matchField: '',
    copyFields: [],
    tempItem: {},
  }
) {
  const data = JSON.parse(JSON.stringify(options.data));
  const childData = copyFields(data, options.field, options.copyFields);

  // 过滤重复数据
  const repeatList = [];
  childData.forEach((item) => {
    if (!repeatList.some((item2) => item[options.matchField] === item2[options.matchField])) {
      repeatList.push(item);
    }
  });
  return repeatList.map((item) => ({ ...item, ...options.tempItem }));
}

export default {
  methods: {
    fillDataStatistics(
      options = {
        data: [],
        field: '',
        matchField: '',
        copyFields: [],
        tempItem: {},
      }
    ) {
      const data = JSON.parse(JSON.stringify(options.data));
      return data.map((item) => {
        const tempData = maxChildData(data); // 所有车型
        const childData = item[options.field] || []; // 当前时间段车型
        item[options.field] = tempData.map((item2) => ({
          ...item2,
          ...(childData.filter((ride) => ride[options.matchField] === item2[options.matchField])[0] || {}),
        })); // 数据填充：遍历所有车型，当前时间段车型数据替换相同车型的遍历数据
        return item;
      });
    },
  },
};
